import { IEntity } from '../types';
import { EntityService } from './EntityService';

export interface IAskAiResponse {
    response: string;
    summarised: boolean;
    summary?: string;
}

export interface ITopicSummaryResponse {
    updated: boolean;
    topicSummary?: string;
}

export interface ChatMessage {
    role: "user" | "assistant" | "summary";
    content: string;
    createdOn?: string;
    userName?: string;
}

export class AiService extends EntityService<IEntity> {
    private zedxApiURL: string = process.env.REACT_APP_ZedX_Non_Odata_API!;

    constructor() {
        super('/Ai');
    }

    public async ask(prompt: string, chatId: number): Promise<IAskAiResponse> {
        const endPoint = `${this.zedxApiURL}/ask-ai`;
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const requestBody = {
            prompt,
            timeZone,
            chatId
        };
        return await super.readAnyEndPointValueWithPost(
            endPoint,
            requestBody
        );
    }

    public async getMessages(chatId: number): Promise<ChatMessage[]> {
        const endPoint = `${this.zedxApiURL}/ask-ai/${chatId}/messages`;
        return await super.readAnyEndPointValue(endPoint);
    }

    public async createTopicSummary(chatId: number): Promise<ITopicSummaryResponse> {
        const endPoint = `${this.zedxApiURL}/ask-ai/${chatId}/topic-summary`;
        return await super.readAnyEndPointValueWithPost(
            endPoint,
            {}
        );
    }
}